// @flow
import { sanitizePhoneNumber } from './commonHelpers';

export const formatAddressLine = (
  addressLine: string,
  addressNumber: ?string,
) => {
  if (!addressNumber) return addressLine;
  return `${addressLine} - Nº${addressNumber}`;
};

export const extractAddressNumber = (addressLine: string) => {
  const addressNumberMatch = addressLine.match(/ - Nº([^-]+)$/);
  if (addressNumberMatch && addressNumberMatch[1]) {
    return addressNumberMatch[1];
  }
  return null;
};

export const hideAddressNumber = (addressLine: string) => {
  return addressLine.replace(/ - Nº[^-]+$/, '');
};

export const formatAddressFormValues = (values: Object): Object => {
  const payload = {
    ...values,
    telephone: sanitizePhoneNumber(values.telephone),
    addressLine1: formatAddressLine(values.addressLine1, values.houseNumber),
  };
  delete payload.houseNumber;
  delete payload.noNumber;
  return payload;
};

export const getAddressPhoneError = (error: ?Error): ?string => {
  if (!error) return null;
  try {
    const body = JSON.parse(error.message);
    const fieldErrors = body.errors ?? body;
    const phoneErrors =
      fieldErrors.phone ??
      fieldErrors['phones.number'] ??
      fieldErrors.telephone;
    return [].concat(phoneErrors ?? [])[0] ?? null;
  } catch (e) {
    return null;
  }
};
